import React, {useState} from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import { Link } from "react-router-dom";
import api from "../Api";
import Popup from "../components/PopUP";


export default function AddManufacturer() {
      const [formData, setFormData] = useState({
          company_name: '',
          headquarter: '',
          founding_date: '',
          company_description: '',
          company_history: '',
          logo: '',
          cover_photo: {
            url: '',
            license: '',
            author: '',
            wiki: ''
          },
          product_series: [{ id: 1, description: '' }],
          interesting_facts: [{ id: 1, fact: '' }]
        });

      const [errors, setErrors] = useState({});
      const [toast, setToast] = useState(null);

      const showToast = (message, type) => {
        setToast({ message, type });
      };

      const handleInputChange = (e) => {
      const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
      };

      const handleCoverPhotoChange = (e) => {
        const { name, value } = e.target;
        setFormData({
          ...formData,
          cover_photo: { ...formData.cover_photo, [name]: value }
        });
      };

      const handleProductChange = (id, field, value) => {
        setFormData({
          ...formData,
          product_series: formData.product_series.map(product =>
            product.id === id ? { ...product, [field]: value } : product
          )
        });
      };

      const handleFactChange = (id, value) => {
        setFormData({
          ...formData,
          interesting_facts: formData.interesting_facts.map(fact =>
            fact.id === id ? { ...fact, fact: value } : fact
          )
        });
      };

      const addProduct = () => {
        setFormData({
          ...formData,
          product_series: [...formData.product_series, { id: formData.product_series.length + 1, series: '', description: '' }]
        });
      };

      const removeProduct = (id) => {
        if (formData.product_series.length > 1) {
          setFormData({
            ...formData,
            product_series: formData.product_series.filter(product => product.id !== id)
          });
        }
      };

      const addFact = () => {
        setFormData({
          ...formData,
          interesting_facts: [...formData.interesting_facts, { id: formData.interesting_facts.length + 1, fact: '' }]
        });
      };

      const removeFact = (id) => {
        if (formData.interesting_facts.length > 1) {
          setFormData({
            ...formData,
            interesting_facts: formData.interesting_facts.filter(fact => fact.id !== id)
          });
        }
      };


      const validateForm = () => {
        const newErrors = {};
        if (!formData.company_name.trim()) newErrors.company_name = 'Company name is required';
        if (!formData.headquarter.trim()) newErrors.headquarter = 'Headquarter is required';
        if (!formData.founding_date || !/^\d{4}$/.test(formData.founding_date)) newErrors.founding_date = 'Valid year (YYYY) is required';
        if (!formData.company_description.trim()) newErrors.company_description = 'Description is required';
        if (!formData.company_history.trim()) newErrors.company_history = 'History is required';
        if (!formData.logo.trim()) newErrors.logo = 'Logo URL is required';
        if (!formData.cover_photo.url.trim()) newErrors.cover_photo_url = 'Cover photo URL is required';

        formData.product_series.forEach((product, index) => {
          if (!product.description.trim()) newErrors[`description_${product.id}`] = 'Series description is required';
        });

        formData.interesting_facts.forEach((fact, index) => {
          if (!fact.fact.trim()) newErrors[`fact_${fact.id}`] = 'Fact is required';
        });

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
      };

      const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
          const postData = {
          company_name: formData.company_name,
          headquarter: formData.headquarter,
          founding_date: formData.founding_date,
          company_description: formData.company_description,
          company_history: formData.company_history,
          logo: formData.logo,
          cover_photo: {
            url: formData.cover_photo.url,
            license: formData.cover_photo.license,
            author: formData.cover_photo.author,
            wiki: formData.cover_photo.wiki
          },
          product_series: formData.product_series.map(({ id, ...rest }) => rest),
          interesting_facts: formData.interesting_facts.map(fact => fact.fact)
        };

        console.log("Posting data:", postData);
        try{
          const response = await api.post('/airplane-service/manufacturer/', postData);
          console.log(response.data.detail);
          showToast(response.data.detail, 'success');

          setFormData(
            {
          company_name: '',
          headquarter: '',
          founding_date: '',
          company_description: '',
          company_history: '',
          logo: '',
          cover_photo: {
            url: '',
            license: '',
            author: '',
            wiki: ''
          },
          product_series: [{ id: 1, series: '', description: '' }],
          interesting_facts: [{ id: 1, fact: '' }]
        }
          )

        }
        catch(error){
          console.log("API Error:", error.response.data.detail);
          showToast(error.response.data.detail, 'danger');
        }
    } else{
      showToast('Failed to submit form. Please try again.', 'danger');
    }
    };

    return(
        <>
       
        <Sidebar/>
        <div className="main-wrapper">
      <Header/>

      {/* Content */}
       <Popup
        message={toast?.message}
        type={toast?.type}
        onClose={() => setToast(null)}
        duration={3000}
      />
      <div className="content-wrapper">
        <section className="main-section spacer-y">
          <div className="container">
            <div className="row gy-4">
              <div className="col-xl-12">
                <div className="common_main_bg_wrapper">
                  <div className="common_main_heading_wrapper">
                    <div className="vstack">
                      <nav className="breadcrumb_nav">
                        <ul className="breadcrumb mb-0">
                          <li className="breadcrumb-item">
                            <Link to="/dashboard">Dashboard</Link>
                          </li>
                          <li className="breadcrumb-item">
                            <Link to="/challenge-management">
                              Manufacture Management
                            </Link>
                          </li>
                          <li className="breadcrumb-item text-capitalize">
                            Add New Manufacture
                          </li>
                        </ul>
                      </nav>
                      <h1>Manufacture Management</h1>
                    </div>
                    <div className="d-flex flex-end">
                        <Link to="/manufacturer" className="secondary_btn"> 
                         {/* <img
                      src="/assets/images/Frame (19).svg"
                      alt="Manufacture Management"
                    /> */}
                    View All Manufacturers</Link>
                    </div>
                  </div>
                </div>
                <form onSubmit={handleSubmit}>
                  <div className="common-outer-card mt-4">
                    <div className="common_sub_heading_wrapper">
                      <h2>Add New Manufacturer</h2>
                    </div>
                    <div className="common_content_blk">
                      <div className="row g-4">
                        <div className="col-12 col-sm-6 col-md-4">
                          <div className="form_field">
                            <label>Manufacturer Name</label>
                            <div className="input_field">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Manufacturer/Company name"
                                name="company_name"
                                value={formData.company_name}
                                onChange={handleInputChange}
                              />
                              <span className="error">{errors.company_name}</span>
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-sm-6 col-md-4">
                          <div className="form_field">
                            <label>Headquarter</label>
                            <div className="input_field">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Headquarter"
                                name="headquarter"
                                value={formData.headquarter}
                                onChange={handleInputChange}
                              />
                              <span className="error">{errors.headquarter}</span>
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-sm-6 col-md-4">
                          <div className="form_field">
                            <label>Founding Date</label>
                            <div className="input_field">
                              <input
                                type="number"
                                className="form-control"
                                placeholder="YYYY"
                                min="1900"
                                max="2099"
                                step="1"
                                name="founding_date"
                                value={formData.founding_date}
                                onChange={handleInputChange}
                              />
                              <span className="error">{errors.founding_date}</span>
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-sm-6 col-md-6">
                          <div className="form_field">
                            <label>Logo (URL)</label>
                            <div className="input_field">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter image URL ..."
                                name="logo"
                                value={formData.logo}
                                onChange={handleInputChange}
                              />
                              <span className="error">{errors.logo}</span>
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-sm-6 col-md-6">
                          <div className="form_field">
                            <label>Cover/Background Image (URL)</label>
                            <div className="input_field">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter image URL ..."
                                name="url"
                                value={formData.cover_photo.url}
                                onChange={handleCoverPhotoChange}
                              />
                              <span className="error">{errors.cover_photo_url}</span>
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-sm-6 col-md-4">
                          <div className="form_field">
                            <label>License (Optional)</label>
                            <div className="input_field">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter License detail..."
                                name="license"
                                value={formData.cover_photo.license}
                                onChange={handleCoverPhotoChange}
                              />
                              <span className="error">{errors.license}</span>
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-sm-6 col-md-4">
                          <div className="form_field">
                            <label>Author (Optional)</label>
                            <div className="input_field">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Author detail..."
                                name="author"
                                value={formData.cover_photo.author}
                                onChange={handleCoverPhotoChange}
                              />
                              <span className="error">{errors.author}</span>
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-sm-6 col-md-4">
                          <div className="form_field">
                            <label>Wiki (Optional)</label>
                            <div className="input_field">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Wiki URL ..."
                                name="wiki"
                                value={formData.cover_photo.wiki}
                                onChange={handleCoverPhotoChange}
                              />
                              <span className="error">{errors.wiki}</span>
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-sm-12 col-md-12">
                          <div className="form_field">
                            <label>Company/Manufacturer Description</label>
                            <div className="input_field">
                              <textarea
                                className="form-control"
                                rows="4"
                                placeholder="Write something..."
                                name="company_description"
                                value={formData.company_description}
                                onChange={handleInputChange}
                              />
                              <span className="error">{errors.company_description}</span>
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-sm-12 col-md-12">
                          <div className="form_field">
                            <label>Company/Manufacturer History</label>
                            <div className="input_field">
                              <textarea
                                className="form-control"
                                rows="4"
                                placeholder="Write something ..."
                                name="company_history"
                                value={formData.company_history}
                                onChange={handleInputChange}
                              />
                              <span className="error">{errors.company_history}</span>
                            </div>
                          </div>
                        </div>

                        {formData.product_series.map((product) => (
                          <div className="row mb-3" key={product.id}>

                            <div className="col-11 col-sm-6 col-md-11">
                              <div className="form_field">
                                <label>Product Description</label>
                                <div className="input_field">
                                  <textarea
                                    className="form-control"
                                    rows="2"
                                    placeholder="Describe about series ..."
                                    value={product.description}
                                    onChange={(e) => handleProductChange(product.id, 'description', e.target.value)}
                                  />
                                  <span className="error">{errors[`description_${product.id}`]}</span>
                                </div>
                              </div>
                            </div>

                            <div className="col-1 d-flex align-items-center">
                              {formData.product_series.length > 1 && (
                                <button
                                  type="button"
                                  className="btn btn-danger rounded-pill"
                                  onClick={() => removeProduct(product.id)}
                                >
                                  Remove
                                </button>
                              )}
                            </div>
                          </div>
                        ))}

                        <div className="col-12 col-sm-12 col-md-12">
                          <button
                            type="button"
                            className="primary-btn rounded-pill"
                            onClick={addProduct}
                          >
                            Add Another Series
                          </button>
                        </div>

                        {formData.interesting_facts.map((fact) => (
                          <div className="row my-3" key={fact.id}>
                            <div className="col-12 col-sm-12 col-md-11">
                              <div className="form_field">
                                <label>Interesting Fact</label>
                                <div className="input_field">
                                  <textarea
                                    className="form-control"
                                    rows="4"
                                    placeholder="Write Fact ..."
                                    value={fact.fact}
                                    onChange={(e) => handleFactChange(fact.id, e.target.value)}
                                  />
                                  <span className="error">{errors[`fact_${fact.id}`]}</span>
                                </div>
                              </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-1 d-flex align-items-center">
                              {formData.interesting_facts.length > 1 && (
                                <button
                                  type="button"
                                  className="btn btn-danger rounded-pill"
                                  onClick={() => removeFact(fact.id)}
                                >
                                  Remove
                                </button>
                              )}
                            </div>
                          </div>
                        ))}

                        <div className="col-12 col-sm-12 col-md-12">
                          <button
                            type="button"
                            className="primary-btn rounded-pill"
                            onClick={addFact}
                          >
                            Add Another Fact
                          </button>
                        </div>

                        <div className="main_action_blk hstack gap-3 justify-content-start">
                          <button type="button" className="bg_primary_outline_btn rounded-pill">
                            Cancel
                          </button>
                          <button type="submit" className="primary-btn rounded-pill">
                            Save
                          </button>
                          {errors.submit && <span className="error">{errors.submit}</span>}
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
        </>
    )

}